import {
  Box,
  Container,
  Link,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';

function Support() {
  const theme = useTheme();
  const isCentered = useMediaQuery(theme.breakpoints.up(420));

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          alignItems: isCentered ? 'center' : undefined,
          display: 'flex',
          flexDirection: 'column',
          maxWidth: 420,
          mx: 'auto',
        }}
      >
        <Box sx={{ pb: 3 }}>
          <Typography variant="h5" color="inherit">
            Support the Cutting Board Designer
          </Typography>
        </Box>

        <Box sx={{ pb: 3 }}>
          <Typography color="inherit" align={isCentered ? 'center' : undefined}>
            This tool is free to use, but relies on the generous support of its
            users to cover development and maintenance costs. If you'd like to
            support the Cutting Board Designer, you can click "Buy Now" to make
            a donation for any amount you like. Donations do not unlock any
            additionaly functionality.
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <form
            action="https://www.paypal.com/cgi-bin/webscr"
            method="post"
            target="_blank"
          >
            <input type="hidden" name="cmd" value="_s-xclick" />
            <input
              type="hidden"
              name="encrypted"
              value={process.env.REACT_APP_PAY_PAL_PKCS7}
            />
            <input
              type="image"
              src="https://www.paypalobjects.com/en_US/i/btn/btn_buynowCC_LG.gif"
              name="submit"
              alt="PayPal - The safer, easier way to pay online!"
            />
            <img
              alt=""
              src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif"
              width="1"
              height="1"
            />
          </form>
        </Box>

        <Box sx={{ pt: 4 }}>
          <Typography>
            Have feedback?&nbsp;
            <Link href="mailto:cuttingboarddesigner@gmail.com">
              We'd love to hear it!
            </Link>
          </Typography>
        </Box>
      </Box>
    </Container>
  );
}

export default Support;
